export enum PlacementType {
  Custom = 'custom',
  Fixed = 'fixed',
  FixedPlusCustom = 'fixed-plus-custom',
  MovableLayouts = 'movable-layouts',
}
